// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30xIN","content":"styles_content__UJ2T2","row":"styles_row__26Uoz","footer":"styles_footer__1iqRZ","phraseLength":"styles_phraseLength__2Ijzf"};